var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConsolidationMeestTableUser',{attrs:{"filterGetParams":_vm.filterGetParams,"countFilterParams":_vm.countFilterParams,"navTabs":_vm.navTabs},on:{"changeTab":_vm.changeTab,"filter":_vm.filter,"changeFilter":_vm.changeFilter,"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"sentConsolidationMeest":_vm.sentConsolidationMeest}})
}
var staticRenderFns = []

export { render, staticRenderFns }